import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gt-sidebar__wrapper" }
const _hoisted_2 = { class: "gt-sidebar__head" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "gt-sidebar__logo",
  src: "/static/app/gt-sidebar-logo.svg",
  alt: "tt-logo-image"
}
const _hoisted_5 = { class: "gt-sidebar__logo-arrow" }
const _hoisted_6 = { class: "gt-sidebar__toggler" }
const _hoisted_7 = { class: "gt-sidebar__language relative" }
const _hoisted_8 = { class: "gt-sidebar__body" }
const _hoisted_9 = { class: "gt-sidebar-menu-link__icon" }
const _hoisted_10 = { class: "gt-sidebar-menu-link__title" }
const _hoisted_11 = { class: "ds-caption ds-caption--size_sm ds-caption--color_white ds-caption--appearance_nowrap ds-caption--medium" }
const _hoisted_12 = { class: "gt-sidebar-menu-link__icon" }
const _hoisted_13 = { class: "gt-sidebar-menu-link__title" }
const _hoisted_14 = { class: "ds-caption ds-caption--size_sm ds-caption--color_white ds-caption--appearance_nowrap ds-caption--medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_arrow_right = _resolveComponent("i-arrow-right")!
  const _component_language_selector = _resolveComponent("language-selector")!
  const _component_i_close = _resolveComponent("i-close")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["gt-sidebar", { 'closed' : $setup.isClosed }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "gt-sidebar__logo-wrapper",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isClosed ? $setup.toggleSidebar() : () => {}))
        }, [
          ($setup.logo_alternative)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "gt-sidebar__logo",
                src: $setup.logo_alternative,
                alt: "tt-logo-image"
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("img", _hoisted_4)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_i_arrow_right)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(["gt-switch pointer", { 'closed' : $setup.isClosed }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleSidebar()))
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("div", { class: "gt-switch__element" }, null, -1)
          ]), 2)
        ]),
        ($setup.props?.close)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_language_selector)
              ]),
              _createElementVNode("div", {
                class: "gt-sidebar__close-btn pointer",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.props?.close()))
              }, [
                _createVNode(_component_i_close)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuItems, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `element_${index}`
          }, [
            ($setup.hasAccess(item.roles))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (item?.routeName)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: _normalizeClass(["gt-sidebar-menu-link ds-link", { 'closed' : $setup.isClosed }]),
                        to: {name: item.routeName},
                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.props.close ? $setup.props.close() : () => {}))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "button_img" }))
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("p", _hoisted_11, _toDisplayString(item.title), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to", "class"]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["gt-sidebar-menu-link", { 'closed' : $setup.isClosed }])
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "button_img" }))
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("p", _hoisted_14, _toDisplayString(item.title), 1)
                        ])
                      ], 2))
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ])
  ], 2))
}